import React, { useEffect, useState } from 'react';
import SeeDocuments from '../../pages/Charge/SeeDocuments';
import ChargeService from '../../../services/charge';
import { filterData } from '../../../utils/function';
import { CODES } from '../../../utils/httpCodes';
import { simpleAlerts } from '../../../utils/alerts';
import MainPagination from '../Main/PaginationMain';
import PreviewIcon from '@mui/icons-material/Preview';
import CancelIcon from '@mui/icons-material/Cancel';
import SaveIcon from '@mui/icons-material/Save';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import PageviewIcon from '@mui/icons-material/Pageview';
import EngineeringIcon from '@mui/icons-material/Engineering';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import { allowedTypesConformity, maxFileSizeConformityMB } from '../../config/allowedTypes';
import { timeStampString, getDateOL } from '../../../utils/function';
import _ from 'lodash';
import { Modal, Box, TextField, Button, Typography } from '@mui/material';
import Swal from 'sweetalert2';


const columns = [
  { id: 'id_cargo', label: '#', width: 30, align: 'center', },
  { id: 'fechaEntrega', label: 'Entrega', width: 60, align: 'center', },
  { id: 'numdoc', label: 'Documento', width: 50, align: 'left', },
  { id: 'trabajador', label: 'Trabajador', width: 120, align: 'left', },
  { id: 'equipo_id', label: 'Equipo', width: 120, align: 'left', },
  { id: 'nroSerie', label: 'Serial', width: 80, align: 'center', },
  { id: 'tipoCargo_id', label: 'Tipo Cargo', width: 80, align: 'left', },
  { id: 'ruta', label: 'Cargo', width: 100, align: 'center', },
  { id: 'dev', label: 'Devolu.', align: 'center', width: 100 },
 // { id: 'actions', label: 'Acciones', width: 40, align: 'center', },
];
const columnsMap = {
  equipo_id: 'equipo.nombre',
  nroSerie: 'equipo.nroSerie',
  tipoCargo_id: 'tipoCargo.descripcion',
};
function getValueFromPath(obj, path) {
  const pathArray = path?.split('.');
  let value = obj;
  for (const key of pathArray) {
    if (value === null || value === undefined) {
      return ''; // O algún valor por defecto
    }
    value = value[key];
  }
  return value;
}

const BodySearchCharge = ({ handleOpenLoad, handleCloseLoad, setTitleLoad, data, editCharge, search, totalPages, page, setPage, getCharge }) => {
  const url = window.location.pathname;
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [urlDocument, setUrlDocument] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [openDevolucion, setOpenDevolucion] = useState(false);
  const [infoDevolucion, setInfoDevolucion] = useState({
    fechaEntrega: '',
    observaciones: '',
    row: null
  });

  const [resultSearch, setResultSearch] = useState([]);


  useEffect(() => {
    getCharge();
  }, []);

  useEffect(() => {
    setTableData(data);
  }, [data]);


  useEffect(() => {
    const filtered = filterData(tableData, search, ['numdoc', 'trabajador']);
    setResultSearch(filtered);
  }, [tableData, search]);
  
  //let resultSearch = filterData(data, search, ['numdoc', 'trabajador']);

  //let resultSearch = filterData(tableData, search, ['numdoc', 'trabajador']);

  const deleteChargeSafe = async (row) => {
    if (row.conforDev) {
      simpleAlerts(
        'No se puede eliminar el cargo porque tiene una devolución firmada.',
        'warning'
      );
      return;
    }
  
    confirmDelete(
      'Eliminar cargo',
      'Este cargo se eliminará completamente del sistema.',
      async () => {
        await deleteCharge(row);
        setResultSearch(prev => prev.filter(item => item.id_cargo !== row.id_cargo));
      }
    );
  };

  const deleteCharge = async (row) => {
    handleOpenLoad();
    setTitleLoad('Eliminando ...');
    try {
      const result = await ChargeService.deleteCharge(url, row?.id_cargo);
      if (result.status === CODES.DELETE_204) {
        simpleAlerts('Cargo eliminado', 'success');
        getCharge();
      } else {
        simpleAlerts(result?.response?.data?.message || 'Error al eliminar', 'error');
      }
      return [];
    } catch (error) {
      console.log(`Error en deleteCharge: ${error}`);
    } finally {
      handleCloseLoad();
      setTitleLoad(null);
    }
  }

  const getFileType = (file) =>
    Object.keys(allowedTypesConformity).find(type => allowedTypesConformity[type].includes(file.type));

  const isFileSizeValid = (file) => {
    const fileType = getFileType(file);
    if (!fileType) return false;
    return file.size / (1024 * 1024) <= maxFileSizeConformityMB[fileType];
  };

  const handleFileChange = (event, infoCargo, type) => {
    let upd = _.cloneDeep(tableData);
    const idx = upd.findIndex(e => +e.id_cargo === +infoCargo.id_cargo);

    if (type === 1) {
      const file = event.target.files[0];
      if (!file) return;
      if (!getFileType(file) || !isFileSizeValid(file)) {
        simpleAlerts('Archivo no válido');
        return;
      }
      upd[idx].conformidadName = file.name;
      upd[idx].conformidadFile = file;
    } else {
      upd[idx].conformidadName = null;
      upd[idx].conformidadFile = null;
    }
    setTableData(upd);
  };

  const saveConformity = async (info) => {
    try {
      handleOpenLoad();
      setTitleLoad('Guardando archivo firmado...');

      const ext = info.conformidadName.split('.').pop();
      const nameFile = `${info.numdoc}${timeStampString()}-conf.${ext}`;
      const file = new File([info.conformidadFile], nameFile, { type: info.conformidadFile.type });

      const formData = new FormData();
      formData.append('myFile', file);
      formData.append('id_cargo', info.id_cargo);
      formData.append('nameFile', nameFile);

      const result = await ChargeService.uploadConformity(url, formData);

      if (result.status === CODES.SUCCESS_200) simpleAlerts('Archivo firmado guardado', 'success');
      else simpleAlerts('Error al guardar', 'error');
    } finally {
      handleCloseLoad();
      setTitleLoad(null);
      getCharge();
    }
  };

  const saveDevolucionFirmada = async (info) => {
    try {
      handleOpenLoad();
      setTitleLoad('Guardando devolución firmada...');
  
      const ext = info.conformidadName.split('.').pop();
      const nameFile = `${info.numdoc}${timeStampString()}-devfirm.${ext}`;
      const file = new File([info.conformidadFile], nameFile, { type: info.conformidadFile.type });

      const formData = new FormData();
      formData.append('myFile', file);
      formData.append('id_cargo', info.id_cargo);
      formData.append('nameFile', nameFile);
  
      await ChargeService.uploadDevolucionFirmada(url, formData);
  
      simpleAlerts('Devolución firmada guardada correctamente', 'success');
    } finally {
      handleCloseLoad();
      setTitleLoad(null);
      getCharge();
    }
  };

  const deleteConformity = async (row) => {
    try {
      handleOpenLoad();
      setTitleLoad('Borrando conformidad...');
      await ChargeService.deleteConformity(url, row.id_cargo);
    } finally {
      handleCloseLoad();
      setTitleLoad(null);
      getCharge();
    }
  };

  const deleteDevolucionFirmada = async (row) => {
    try {
      handleOpenLoad();
      setTitleLoad('Eliminando devolución firmada...');
  
      await ChargeService.deleteDevolucionFirmada(url, row.id_cargo);
  
      const upd = _.cloneDeep(tableData);
      const idx = upd.findIndex(e => +e.id_cargo === +row.id_cargo);
      if (idx !== -1) {
        upd[idx].conforDev = null;   // 🔁 reactiva eliminar cargo
      }
      setTableData(upd);
  
      simpleAlerts('Devolución firmada eliminada', 'success');
    } finally {
      handleCloseLoad();
    }
  };
  

  const confirmarGenerarDevolucion = async () => {
    const { row, fechaEntrega, observaciones } = infoDevolucion;

    if (!fechaEntrega) {
      simpleAlerts('Ingrese fecha de entrega', 'warning');
      return;
    }

    try {
      handleOpenLoad();
      setTitleLoad('Registrando devolución...');

      const dataEnviar = {
        ...row,
        tipoCargo: 1,
        fechaEntrega,
        observaciones,
      };

      const response = await ChargeService.saveCharge(url, dataEnviar);

      if (response.status === CODES.CREATE_201) {
        // 👉 USA EL MISMO ROW, YA TIENE id_cargo
        await saveDevolucion(dataEnviar);
        simpleAlerts('Devolución generada correctamente', 'success');
        setOpenDevolucion(false);
        getCharge();
      }
    } finally {
      handleCloseLoad();
      setTitleLoad(null);
    }
  };

  const saveDevolucion = async (info) => {
    info.fechaGeneracion = getDateOL();

    try {
      handleOpenLoad();
      setTitleLoad('Generando documento devolución...');

      const result = await ChargeService.saveDevolucion(url, info);

      if (result.status === CODES.CREATE_201) {
        simpleAlerts(result?.data?.message || 'Devolución generada', 'success');
      } else {
        simpleAlerts(result?.response?.data?.message || 'Error al generar devolución', 'error');
      }
    } catch (error) {
      console.log(`Error en saveDevolucion: ${error}`);
    } finally {
      getCharge();
      handleCloseLoad();
      setTitleLoad(null);
    }
  };

  const deleteDevolucion = async (row) => {
    try {
      handleOpenLoad();
      setTitleLoad('Eliminando devolución...');
      await ChargeService.deleteDevolucion(url, row.id_cargo);
      getCharge();
    } finally {
      handleCloseLoad();
      setTitleLoad(null);
    }
  };

  const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 420,
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 2,
    p: 3,
  };

  const confirmDelete = async (title, text, callback) => {
    const result = await Swal.fire({
      title,
      text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    });
  
    if (result.isConfirmed && typeof callback === 'function') {
      await callback();
    }
  };

  return (
    <div className='body-table table-responsive'>
      <Modal open={openDevolucion} onClose={() => setOpenDevolucion(false)}>
        <Box sx={styleModal}>
          <Typography variant="h6" mb={2}>
            Generar devolución
          </Typography>
          <TextField
            fullWidth
            type="date"
            label="Fecha de entrega"
            InputLabelProps={{ shrink: true }}
            value={infoDevolucion.fechaEntrega || ''}
            onChange={e =>
              setInfoDevolucion({ ...infoDevolucion, fechaEntrega: e.target.value })
            }
            sx={{ mb: 2 }}
          />

          <TextField
            fullWidth
            label="Observaciones"
            multiline
            rows={3}
            value={infoDevolucion.observaciones || ''}
            onChange={e =>
              setInfoDevolucion({ ...infoDevolucion, observaciones: e.target.value })
            }
            sx={{ mb: 3 }}
          />

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
            <Button variant="outlined" onClick={() => setOpenDevolucion(false)}>
              Cancelar
            </Button>
            <Button variant="contained" color="success" onClick={confirmarGenerarDevolucion}>
              Generar
            </Button>
          </Box>
        </Box>
      </Modal>
      <SeeDocuments
        open={open}
        handleClose={handleClose}
        handleOpenLoad={handleOpenLoad}
        handleCloseLoad={handleCloseLoad}
        setTitleLoad={setTitleLoad}
        urlDocument={urlDocument}
      />
      <div className="container">
        <div className="body-table-wrapper mt-4">
          <table className="table table-bordered table-hover">
            <thead className="table-dark sticky-top">
              <tr>
                {columns.map((col) => (
                  <th
                    scope="col"
                    key={col.id}
                    style={{
                      textAlign: col.align,
                      width: `${col.width}px`,
                      maxWidth: `${col.width}px`,
                    }}
                  >
                    {col.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {resultSearch?.map((row, idx) => {
                return (
                  <tr key={idx}>
                    {columns.map((col) => {
                      const value = col.id in columnsMap
                        ? getValueFromPath(row, columnsMap[col.id])
                        : row[col.id];

                      return (
                        <td
                          key={col.id}
                          style={{
                            textAlign: col.align,
                            width: `${col.width}px`,
                            maxWidth: `${col.width}px`,
                          }}
                        >

                          {/* ===== NUEVA COLUMNA CONFOR ===== */}
                          {col.id === 'dev' ? (

                            <div className="d-flex gap-1 justify-content-center">

                              {/* ❌ NO EXISTE DEVOLUCIÓN */}
                              {!row.devolucion && (
                                <button
                                  className="btn btn-outline-success btn-sm buttons-grid"
                                  title="Generar devolución"
                                  onClick={() => {
                                    setInfoDevolucion({ fechaEntrega: '', observaciones: '', row });
                                    setOpenDevolucion(true);
                                  }}>
                                  <EngineeringIcon sx={{ fontSize: 17 }} />
                                </button>
                              )}

                              {/* ✅ EXISTE DEVOLUCIÓN */}
                              {row.devolucion && (
                                <>
                                  {/* 👁 Ver devolución */}
                                  <button
                                    className="btn btn-outline-dark btn-sm buttons-grid"
                                    title="Ver devolución"
                                    onClick={() => { handleOpen(); setUrlDocument(row.devolucion); }}>
                                    <PageviewIcon sx={{ fontSize: 17 }} />
                                  </button>

                                  {!row.conforDev && !row.conformidadName && (
                                    <button
                                      className="btn btn-outline-primary btn-sm buttons-grid"
                                      title="Editar devolución"
                                      onClick={() => editCharge(row)}>
                                      <i className="fa-solid fa-pen-to-square"></i>
                                    </button>
                                  )}
                                  {/* 📤 Subir devolución firmada */}
                                  {!row.conforDev && !row.conformidadName && (
                                    <>
                                      <input
                                        type="file"
                                        id={`fileSigned-${row.id_cargo}`}
                                        hidden
                                        accept=".pdf,.jpg,.jpeg,.png"
                                        onChange={(e) => handleFileChange(e, row, 1)}
                                      />
                                      <button
                                        className="btn btn-outline-warning btn-sm buttons-grid"
                                        title="Subir devolución firmada"
                                        onClick={() => document.getElementById(`fileSigned-${row.id_cargo}`).click()}>
                                        <CloudUploadIcon sx={{ fontSize: 17 }} />
                                      </button>
                                    </>
                                  )}

                                  {/* 💾 Guardar firmada */}
                                  {row.conformidadName && (
                                    <>
                                      <button
                                        className="btn btn-outline-success btn-sm buttons-grid"
                                        title="Guardar devolución firmada"
                                        onClick={() => saveDevolucionFirmada(row)}>
                                        <SaveIcon sx={{ fontSize: 17 }} />
                                      </button>

                                      <button
                                        className="btn btn-outline-danger btn-sm buttons-grid"
                                        title="Cancelar"
                                        onClick={() => handleFileChange(null, row, 0)}>
                                        <CancelIcon sx={{ fontSize: 17 }} />
                                      </button>
                                    </>
                                  )}

                                  {/* 👁 Ver firmada */}
                                  {row.conforDev && (
                                    <>
                                      <button
                                        className="btn btn-outline-success btn-sm buttons-grid"
                                        title="Ver devolución firmada"
                                        onClick={() => { handleOpen(); setUrlDocument(row.conforDev); }}>
                                        <PreviewIcon sx={{fontSize: '1.05rem'}} />
                                      </button>

                                      <button
                                        className="btn btn-outline-secondary btn-sm buttons-grid"
                                        title="Eliminar devolución firmada"
                                       // onClick={() => deleteDevolucionFirmada(row)}
                                        onClick={() =>
                                          confirmDelete(
                                            '¿Eliminar devolución?',
                                            'Esta acción no se puede deshacer.',
                                            () => deleteDevolucionFirmada(row)
                                          )
                                        }
                                        
                                        >
                                        <DeleteOutlineIcon sx={{ fontSize: '1.05rem'}} />
                                      </button>
                                    </>
                                  )}

                                  {/* 🗑 Eliminar devolución */}
                                  {!row.conforDev && (
                                    <button
                                      className="btn btn-outline-danger btn-sm buttons-grid"
                                      title="Eliminar devolución"
                                      // onClick={() => deleteDevolucion(row)}
                                      onClick={() =>
                                        confirmDelete(
                                          '¿Eliminar devolución?',
                                          'Esta acción no se puede deshacer.',
                                          () => deleteDevolucion(row)
                                        )
                                      }
                                      >
                                      <DeleteIcon sx={{  fontSize: '1.05rem' }} />
                                    </button>
                                  )}
                                </>
                              )}
                            </div>

                          ) :
                            /* ===== BLOQUE ORIGINAL ===== */
                            col.id === 'actions' ? null :
                              col.id === 'ruta' ? (

                                <div className="d-flex gap-1 justify-content-center">
                                  {/* ====== CARGO ====== */}
                                  <button
                                    className="btn btn-outline-danger btn-sm buttons-grid"
                                    title="Ver cargo"
                                    onClick={() => { handleOpen(); setUrlDocument(row.ruta); }}>
                                    <i className="fa-solid fa-file-pdf" style={{ fontSize: '1.05rem' }}></i>
                                  </button>
                              
                                  {/* ====== CARGO FIRMADO ====== */}
                                  {row.conformidad ? (
                                    <>
                                      <button
                                        className="btn btn-outline-dark btn-sm buttons-grid"
                                        title="Ver cargo firmado"
                                        onClick={() => { handleOpen(); setUrlDocument(row.conformidad); }}>
                                        <PageviewIcon sx={{ fontSize: 17 }} />
                                      </button>
                              
                                      <button
                                        className="btn btn-outline-danger btn-sm buttons-grid"
                                        title="Eliminar cargo firmado"
                                        //onClick={() => deleteConformity(row)}
                                        onClick={() =>
                                          confirmDelete(
                                            '¿Eliminar Cargo firmado?',
                                            'Esta acción no se puede deshacer.',
                                            () => deleteConformity(row)
                                          )
                                        }
                                        >
                                        <DeleteIcon sx={{ fontSize: 17 }} />
                                      </button>
                                    </>
                                  ) : row.conformidadName ? (
                                    <>
                                      <button
                                        className="btn btn-outline-success btn-sm buttons-grid"
                                        title="Guardar cargo firmado"
                                        onClick={() => saveConformity(row)}>
                                        <SaveIcon sx={{ fontSize: 17 }} />
                                      </button>
                              
                                      <button
                                        className="btn btn-outline-danger btn-sm buttons-grid"
                                        title="Cancelar"
                                        onClick={() => handleFileChange(null, row, 0)}>
                                        <DeleteOutlineIcon sx={{ fontSize: 17 }} />
                                      </button>
                                    </>
                                  ) : (
                                    <>
                                      <input
                                        type="file"
                                        id={`fileCargo-${row.id_cargo}`}
                                        style={{ display: 'none' }}
                                        accept=".pdf,.jpg,.jpeg,.png"
                                        onChange={(e) => handleFileChange(e, row, 1)}
                                      />
                                      <button
                                        className="btn btn-outline-warning btn-sm buttons-grid"
                                        title="Subir cargo firmado"
                                        onClick={() => document.getElementById(`fileCargo-${row.id_cargo}`).click()}>
                                        <CloudUploadIcon sx={{ fontSize: 17 }} />
                                      </button>
                                    </>
                                  )}
                                  <div className="d-flex gap-1 ms-1">

                                    <button
                                      className="btn btn-outline-dark btn-sm buttons-grid"
                                      title="Editar cargo"
                                      onClick={() => editCharge(row)}>
                                      <i className="fa-solid fa-pen-to-square"></i>
                                    </button>

                                    {/* 🗑 Eliminar cargo SOLO si NO tiene cargo firmado NI devolución firmada */}
                                    {!row.conformidad && !row.conforDev && (
                                      <button
                                        className="btn btn-outline-danger btn-sm buttons-grid"
                                        title="Eliminar cargo"
                                        onClick={() => deleteChargeSafe(row)}
                                        >
                                        <i className="fa-solid fa-trash"></i>
                                      </button>
                                    )}

                                  </div>

                                </div>
                              ) 
                              :
                              (col.type === 'number' && col.format) ? col.format(value) : value
                          }
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>

          </table>
        </div>
      </div>
      <MainPagination
        size={'small'}
        totalPages={totalPages}
        page={page}
        setPage={setPage}
      />
    </div>
  )
}

export default BodySearchCharge